export default __webpack_public_path__ + "static/media/world.42047e2e.svg";